{
  "aboutAICompanion": "关于AI童伴",
  "aboutUs": "关于我们",
  "accountDeleteFailed": "注销失败",
  "accountDeleted": "账号已注销",
  "accountLogoffSuccess": "注销成功",
  "accountSecurity": "账号安全",
  "activateNow": "立即开通",
  "add": "添加",
  "addAvatarHint": "为宝贝添加一个可爱的头像吧",
  "addChild": "添加宝贝",
  "addDevice": "添加设备",
  "addFriend": "添加好友",
  "addProfile": "添加档案",
  "age": "{age}岁",
  "ago": "前",
  "agree": "同意并继续",
  "agreeContinue": "同意并继续",
  "aiGeneratedDisclaimer": "内容由AI生成，仅供参考",
  "allDevices": "全部设备",
  "and": "和",
  "androidNotReleased": "暂未发布Android版本",
  "appName": "AI童伴",
  "appNotInstalled": "请先下载APP后再打开，如下载后仍无法唤起应用，请尝试使用设备自带浏览器或其他主流浏览器进行扫码",
  "appleAuthCanceled": "Apple登录已取消",
  "appleLoginFailed": "Apple登录失败：",
  "areaCode": "+86",
  "authExpired": "登录已过期，请重新登录",
  "authRequestFailed": "授权请求失败",
  "autoRegister": "未注册手机号验证后自动注册",
  "avatar": "头像",
  "avatarTip": "点击更换头像",
  "avatarUploadFailed": "上传头像失败",
  "babyInfo": "宝贝信息",
  "babyNickname": "宝贝昵称",
  "badGateway": "服务器繁忙，请稍后重试",
  "bind": "绑定",
  "bindFailedRestart": "绑定失败，请重启设备后重试",
  "bindFailedRetry": "绑定失败，请重试",
  "bindSuccess": "设备绑定成功",
  "bindSuccessCongrats": "恭喜你绑定成功！",
  "bindSuccessPlayTip": "快来学习怎么和我玩吧~",
  "operationGuideLearned": "我学会啦~",
  "operationGuideVideo": "操作指引视频",
  "boundDevices": "已绑定 {count} 个设备",
  "boy": "男孩",
  "cancel": "取消",
  "cannotFindQRCode": "找不到二维码？请选择您的设备型号",
  "captcha": "验证码",
  "captchaRequired": "请输入验证码",
  "captchaSendFailed": "验证码发送失败",
  "captchaSent": "验证码已发送",
  "checkForUpdates": "检查新版本",
  "checkInPoints": "签到得积分",
  "checkSpamFolder": "若未收到验证码，请检查垃圾邮件箱",
  "checkUpdateFailed": "检查更新失败，请稍后重试",
  "childId": "童心ID",
  "childNickname": "孩子昵称",
  "childProfile": "宝贝档案",
  "childProfileSubtitle": "让每一分关爱都陪TA茁壮成长",
  "childProfileTitle": "童心档案",
  "childrenMusic": "儿歌音乐",
  "chooseFromAlbum": "从手机相册选择",
  "chooseMasterDesc": "关联童心档案的设备\n将共享记忆数据",
  "chooseMasterTitle": "选择小主人",
  "comingSoon": "即将上线",
  "companionDays": "已陪伴{days}天！",
  "companionNoteDesc": "每日成长动态",
  "companionNoteTitle": "记忆岛",
  "companyName": "杭州千亿灵境智能科技有限公司",
  "compareYesterday": "较昨日",
  "completeInfo": "完善资料",
  "confirm": "确定",
  "confirmDelete": "确认注销账号？",
  "confirmDeleteFriend": "确认删除好友",
  "confirmLogout": "确认退出登录？",
  "confirmPronunciation": "请确认发音是否正确",
  "confirmSwitch": "确定更换？",
  "confirmUnbind": "确定解绑？",
  "confirmUnbindDevice": "确定解绑该设备？",
  "connectNetwork": "连接网络",
  "content": "内容",
  "continue": "继续",
  "copy": "复制",
  "copyFailed": "复制失败",
  "copyFailedRetry": "复制失败，请重试",
  "copySuccess": "复制成功",
  "copyright": "浙ICP备2025168047号-1",
  "createNew": "新建",
  "createProfile": "新建档案",
  "current": "当前",
  "currentVersion": "当前版本",
  "customerService": "咨询客服",
  "dailyPlayback": "每日回放",
  "dateOfBirth": "出生日期",
  "day": "日",
  "days": "天",
  "daysWithDevice": "一起{days}天",
  "deleteAccount": "注销账号",
  "deleteAccountPermanent": "注销账号后，您的账户信息将被永久删除，且无法恢复",
  "deleteConfirmTitle": "确定删除档案吗？",
  "deleteFailed": "删除失败",
  "deleteFailedTitle": "操作失败",
  "deleteFriend": "删除好友",
  "deleteProfile": "删除档案",
  "deleteProfileWarning": "删除后所有童心档案关联数据将清空。请确保删除前已解绑所有设备。",
  "deleteSuccess": "删除成功",
  "deleteWarning": "删除后，将无法联系，消息记录清空。",
  "description": "如果您有任何问题,可以通过邮件联系我们,我们很乐意为您解答!",
  "developer": "开发者",
  "device": "设备名称：",
  "deviceId": "设备ID",
  "deviceLanguage": "回复语言",
  "deviceManagement": "设备管理",
  "deviceName": "设备名称",
  "deviceNameRequired": "设备名称不能为空",
  "deviceNameValidation": "设备名称只能包含中文、英文字母和数字",
  "deviceNotFound": "设备不存在",
  "deviceNotUnbound": "设备未解绑",
  "deviceNotUnboundDesc": "当前账号仍有绑定设备，注销前请确保所有设备已解除绑定。",
  "deviceReady": "设备已开机",
  "deviceStillLinkedWarning": "仍关联{deviceCount}台设备，请解绑或更换关联宝贝",
  "diary": "日记",
  "disabled": "已停用",
  "disagree": "不同意",
  "done": "完成",
  "download": "立即下载",
  "editDeviceName": "修改昵称",
  "editProfile": "编辑档案",
  "emptyDiarySubtitle": "快去多聊聊天吧~",
  "emptyDiaryTitle": "聊天内容太少，无法生成总结",
  "enterBabyNicknamePlaceholder": "请输入宝贝昵称",
  "enterCharacters": "请输入2-16个字符",
  "enterDeviceName": "请输入设备名称",
  "enterFullCode": "请输入完整的验证码",
  "enterFullPhoneNumber": "请输入完整的手机号",
  "enterNickname": "请输入昵称",
  "enterNicknamePlaceholder": "请输入昵称",
  "enterPhoneNumber": "请输入手机号",
  "enterPhoneTitle": "绑定手机号",
  "enterValidCode": "请输入正确的验证码",
  "exit": "退出",
  "fast": "快",
  "featuredContent": "故事知识",
  "female": "女生",
  "fetchFailed": "获取失败",
  "fillCompleteInfo": "请填写完整信息",
  "firmwareInfo": "固件信息",
  "firstLoginRequirePhone": "首次使用Apple ID登录需要先绑定手机号",
  "friendFeatureNotice": "好友功能正在逐步开放，目前仅部分设备支持。",
  "friendLimit": "每位用户最多可添加5位好友。",
  "friendListTitle": "好友列表",
  "friends": "好友",
  "girl": "女孩",
  "goCheck": "去查看",
  "goToSettings": "前往设置",
  "goUpdate": "去更新",
  "gotIt": "我知道了",
  "growthBoard": "成长看板",
  "helpCenter": "帮助中心",
  "home": "首页",
  "hour": "小时",
  "id": "ID",
  "imageDesc": "待绑定状态示意图",
  "imagePlaceholder": "图片占位",
  "inputPairingCode": "输入配对码",
  "invalidResponse": "无效的响应",
  "invalidToken": "无效的身份验证令牌",
  "justNow": "刚刚",
  "keepChatting": "继续聊天，解锁报告吧~",
  "knows": "知道了",
  "linkedChild": "关联宝贝",
  "linkedDevices": "关联设备",
  "loading": "加载中...",
  "login": "登录",
  "loginFailed": "登录失败",
  "loginRegister": "登录/注册",
  "loginSuccess": "登录成功",
  "loginWithApple": "使用Apple ID登录",
  "logout": "退出登录",
  "logoutFailed": "退出登录失败",
  "male": "男生",
  "manual": "说明书",
  "map": "地图",
  "me": "我的",
  "members": "位成员",
  "messageSetting": "消息设置",
  "minute": "分钟",
  "minuteShort": "分",
  "month": "月",
  "musicMember": "音乐会员授权绑定",
  "myBabies": "我的宝贝",
  "myDevices": "我的设备",
  "myFavorites": "我的收藏",
  "myPoints": "我的积分",
  "namePronunciation": "发音",
  "navTitle": "配对码绑定-引导",
  "neteaseMusic": "网易云音乐",
  "networkError": "网络连接失败，请检查网络",
  "networkGuideTip": "请确保设备处于配网状态并靠近手机",
  "networkGuideTitle": "联网流程",
  "networkNotConnected": "网络未连接，请检查网络后重试",
  "newVersionFound": "发现新版本",
  "noMoreContent": "没有更多了~",
  "next": "下一步",
  "nickname": "昵称",
  "nicknameFormat": "昵称只能包含中文、英文、数字",
  "nicknameLength1to8": "昵称长度为1-8个字符",
  "nicknameLength2to16": "昵称长度需要2-16个字符",
  "noChild": "暂无宝贝，快去添加吧",
  "noFriends": "暂时没有找到好友",
  "noLinkedChild": "未关联",
  "noNewVersion": "当前已是最新版本",
  "notEnoughContent": "聊天内容不足，暂时无法生成报告。",
  "offline": "离线",
  "online": "在线",
  "openApp": "返回App",
  "orderExpired": "订单已过期",
  "orderExpiredDesc": "订单已过期，请返回App重新下单",
  "orderId": "订单号",
  "other": "其他",
  "otherLoginMethods": "其他登录方式",
  "pairingCodeTip": "请开启设备，并输入语音播报的配对码",
  "paymentFailed": "支付失败",
  "paymentFailedDesc": "支付未成功，请返回App重试",
  "paymentProcessing": "支付处理中",
  "paymentProcessingDesc": "支付正在处理中，请稍后查看结果",
  "paymentSuccessful": "支付成功",
  "peopleUnit": "人",
  "personalInfo": "个人信息",
  "phone": "手机号",
  "phoneInvalid": "请输入有效的手机号码",
  "phoneNumber": "请输入手机号",
  "phonePlaceholder": "手机号码",
  "phoneRequired": "请输入手机号",
  "pleaseSelect": "请选择",
  "pleaseSelectAChild": "请选择一个孩子",
  "pleaseSelectBirthDate": "请选择出生日期",
  "pleaseSelectLittleMaster": "请选择小主人",
  "powerLock": "关机锁",
  "powerLockDesc": "打开后,无法通过按钮/语音关机",
  "powerOff": "关机",
  "powerOnDevice": "开启设备",
  "prefix": "我已阅读并同意 ",
  "privacyGuide": "隐私保护指引",
  "privacyPolicy": "隐私政策",
  "privilegeRemaining": "特权剩余 ",
  "profile": "宝贝",
  "pullToRefresh": "下拉刷新",
  "queryShutdownStatusError": "查询关机状态出错",
  "queryShutdownStatusFailed": "查询关机状态失败",
  "readAndAgree": "我已阅读并同意",
  "recentActivity": "最近活动",
  "recentInteraction": "最近互动于",
  "reconsider": "我再想想",
  "recommend": "推荐",
  "recommendedSearch": "推荐搜索",
  "refreshComplete": "刷新完成",
  "refreshing": "刷新中...",
  "relationshipWithChild": "与孩子的关系",
  "releaseToRefresh": "松开刷新",
  "remainingFlow": "剩余流量 ",
  "remarkNameRequired": "备注名称不能为空",
  "remotePowerOff": "远程关闭设备",
  "reportUpdated": "报告已更新",
  "requestFailed": "请求失败，请稍后重试",
  "requestNotHandled": "请求未处理",
  "requestTimeout": "请求超时，请稍后重试",
  "resend": "重新发送",
  "resendCaptcha": "{seconds}s后重新获取",
  "save": "保存",
  "saveFailed": "保存失败",
  "loginInfoSaveFailed": "登录信息保存失败",
  "saveSuccess": "保存成功",
  "scanQRCodeToDownload": "请找到说明书或设备上的下载二维码后扫描",
  "search": "搜索",
  "searchCountry": "搜索国家名称/国际冠码",
  "selectBabyForDevice": "为此设备选择一个宝贝",
  "selectBirthDate": "选择出生日期",
  "selectBirthDatePlaceholder": "请选择宝宝出生日期",
  "selectChildProfile": "请选择童心档案",
  "selectChildToLink": "请选择需要关联的宝贝",
  "selectChildToShareMemory": "选择一个孩子与设备关联",
  "selectDate": "选择日期",
  "selectFromAlbum": "从相册选择",
  "selectIdentity": "选择身份",
  "selectLanguage": "选择语言",
  "selectDialogueLanguage": "选择对话语言",
  "languageSelectDesc": "设备将会使用选中的语言来回复与孩子的对话。后续可在“设备管理”中随时更改。",
  "setLater": "稍后设置",
  "selectRelationship": "选择关系",
  "sendCaptcha": "发送验证码",
  "sendCode": "获取验证码",
  "sendMessage": "发送消息",
  "sendingCode": "发送中...",
  "serviceAgreement": "服务协议",
  "setAvatar": "设置头像",
  "setChildInfo": "设置孩子信息",
  "setLittleMaster": "设置小主人",
  "setRemark": "设置备注",
  "settings": "设置",
  "sharedMemoryDescWithDevice": "关联后，孩子将与设备共享记忆和交互数据",
  "sharedMemoryDescWithProfile": "关联同一童心档案的设备共享记忆数据。",
  "shutdownFailed": "设备关机失败",
  "shutdownStatusTimeout": "查询设备关机状态超时，请稍后重试",
  "shutdownSuccess": "设备关机成功",
  "slow": "慢",
  "sosTitle": "正在求救!",
  "speechSpeed": "回复语速",
  "speedFast": "快速",
  "speedNormal": "标准",
  "speedSlightlyFast": "稍快",
  "speedSlightlySlow": "稍慢",
  "speedSlow": "慢速",
  "step1": "长按设备主按钮3秒开机",
  "step1Desc": "请授权手机的位置信息、蓝牙、附近设备权限，并确保蓝牙和WIFI已开启",
  "step1Title": "第一步：确保授权并开启功能",
  "step2": "听到数字配对码提示音，屏幕蓝灯闪烁",
  "step2Desc": "系统会自动搜索并显示附近的“汤姆猫”设备",
  "step2Title": "第二步：搜索并连接设备",
  "step3Desc": "请选择一个2.4Hz的WiFi网络并输入密码进行连接",
  "step3Title": "第三步：连接网络",
  "subAccountId": "童心ID：",
  "switchAccount": "切换账号",
  "switchDevice": "切换设备",
  "switchFailed": "切换失败",
  "switchSuccess": "切换成功",
  "switchWarning": "切换时，进行中的对话可能不被保留，且定时提醒相关功能会被清除",
  "takePhoto": "拍照",
  "talkTime": "对话时长",
  "tapToSetAvatar": "点击设置头像",
  "termsAndPrivacy": "服务条款与隐私政策",
  "thinkAgain": "我再想想",
  "tickTockSound": "嘀嗒",
  "time": "求救时间：",
  "timeMachine": "时光机",
  "titleSuffix": "正在求救!",
  "todayDialogue": "今日对话",
  "unbind": "解除绑定",
  "unbindDesc": "解绑后设备将无法播放网易云音乐资源。",
  "unbindDevice": "解绑设备",
  "unbindSuccess": "解绑成功",
  "unknownDevice": "未知设备",
  "unknownError": "未知错误",
  "unregisteredAutoRegister": "未注册账号验证后自动注册",
  "updateContent": "更新内容",
  "updateFailed": "更新头像失败",
  "updateLater": "稍后更新",
  "updateSuccess": "更新成功",
  "uploadAvatar": "上传头像",
  "uploadFailed": "上传失败",
  "uploading": "上传中...",
  "uploadingWithEffort": "努力上传中...",
  "userAgreement": "用户协议",
  "userAgreementAndPrivacyPolicy": "用户协议与隐私政策",
  "verificationCode": "请输入验证码",
  "verifyEmailDesc": "请输入发送到您邮箱的验证码",
  "verifyEmailTitle": "验证邮箱",
  "viewGuide": "查看指引",
  "viewMore": "查看更多",
  "weekDays": [
    "日",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六"
  ],
  "weekDaysFull": [
    "周日",
    "周一",
    "周二",
    "周三",
    "周四",
    "周五",
    "周六"
  ],
  "weeklyReport": "周报",
  "weeklyReportNewFeature": "成长看板 · 开启专属报告",
  "weeklyReportTitlePart1": "宝贝的",
  "weeklyReportTitlePart2": "成长看板",
  "weeklyReportComingSoon": "每周帮你读懂孩子",
  "weeklyReportEmptyTitle": "聊天内容太少，无法生成更多分析",
  "weeklyReportDescription": "授权适用于账户下的所有宝贝，每位宝贝都将开启独立的成长周报。开启后将每周自动生成分析报告。",
  "weeklyReportFeature1": "对话亮点\n自动捕捉",
  "weeklyReportFeature2": "智能分析\n个性呈现",
  "weeklyReportFeature3": "每周准时\n自动送达",
  "weeklyReportReserve": "开启成长看板",
  "weeklyReportReserveSuccess": "预约成功",
  "weeklyReportReserved": "已开启，下周见~",
  "weeklyReportDisclaimerPrefix": "点击开启即代表同意授权使用名下所有设备的对话数据进行分析，数据不对外共享。详见 ",
  "welfare": "福利中心",
  "year": "年",
  "yourRelationshipWithBaby": "您与宝贝的关系",
  "yourRole": "您是孩子的",
  "defaultFavoritesFolder": "默认收藏夹",
  "remotePlay": "远程播放",
  "graphicalCaptchaTitle": "请完成图形验证",
  "graphicalCaptchaRefresh": "刷新",
  "graphicalCaptchaUnavailable": "图形验证暂不可用，请稍后重试"
}
